import type { ReactNode } from "react";
import { card } from "@web/theme/theme";

export type CardProps = { className?: string; children: ReactNode; as?: "div" | "section" | "article"; variant?: "default" | "record-header" | "attention-empty" };

/** Surface container: surface color, card radius, gutter padding, theme shadow. */
export function Card({ className = "", as: Tag = "div", children, variant = "default" }: CardProps) {
  const variantClass = { default: "", "record-header": "v365-record-header", "attention-empty": "v365-today-empty" }[variant];
  return <Tag className={`${card} ${variantClass} ${className}`.trim()}>{children}</Tag>;
}
